import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import AdviceSection from '../common/AdviceSection';

import images from '../../style/img/flag/images';

import { getIndicatorCountries } from '../../api';

const CountryReportHome = props => {

	const [countries, setCountries] = useState([]);
	const [alphabet, setAlphabet] = useState([]);
	const [countriesFiltered, setCountriesFiltered] = useState([]);
	const [alphabetFiltered, setAlphabetFiltered] = useState([]);

	useEffect(() => {
		// Update the title of the page
		document.title = props.literals.L22019 +  " - " + props.literals.L22020 + " - " + props.literals.L363;

		try {
			getIndicatorCountries(['20012'], null, null, null, true)
			.then((res) => {
				setCountries(res.resultset);
			})
		} catch (error) {
			console.log('Error fetching data: ', error)
		}
	}, [])

	useEffect(() => {
		filterCountries();
		createLetterNavigation();
	}, [countries])

	const createLetterNavigation = () => {
		let letter = "";
		let index = "";
		let temporalArray = [];
		for (let i=0; i < countries.length; i++)
		{
			if (countries[i] != null)
			{
				letter = countries[i].name.charAt(0);
				index = temporalArray.indexOf(letter);

				if(index == -1){
					temporalArray.push(letter);
				}
			}
		}
		temporalArray.sort();
		setAlphabet(temporalArray);
	}

	const resetFilter = () => {
		setAlphabetFiltered([]);
		setCountriesFiltered(countries);
	}

	const addLetter = (letter) => () => {
		let temporalArray = alphabetFiltered;
		if (temporalArray.indexOf(letter) == -1)
        {
			temporalArray.push(letter); 
        }
        else
        {
			temporalArray.splice(temporalArray.indexOf(letter), 1);
        }
		
		setAlphabetFiltered(temporalArray);
		filterCountries();
	}

	const filterCountries = () => {
		let temporalArray = [];
		if (alphabetFiltered.length === 0)
		{
			temporalArray = countries;
		}
		else
		{
			countries.filter(country => alphabetFiltered.indexOf(country.name.charAt(0)) != -1).forEach(filteredCountry => {
				temporalArray.push(filteredCountry);
			});
		}

		setCountriesFiltered(temporalArray);
	}

	const filterAlphabet = (letter) => {
		if (alphabetFiltered.indexOf(letter) == -1)
        {
			return "";
		}else{
			return "active";
		}
	}

	const onPDFClick = (country) => {
		return () => {
			const url = `/osh-barometer/resources/country-report/country-report_${country}.pdf`;
			window.open(url, "_blank")
		}
	}

	return(
		<div>
			<AdviceSection literals={ props.literals } section={["about-tool","country-report"]} methodologyData={{section: 'osh-context', subsection: 'OSH authorities', indicator: 27}} />

			<section className="filter--letter--section container">
				<ul className="filter--letter--list">
					{/*  FILTER BY LETTER  */}
					{ alphabet.map((letter) => (
						<li className="filter-letter-item" key={letter}>
							<a onClick={ addLetter(letter) } className={ filterAlphabet(letter) } > {letter} </a>
						</li>
					))}
					<li className="reset-item">
						<a onClick={ resetFilter } className="btn-default btn-main-color btn-reset">{ props.literals.L20628 }</a>
					</li>
				</ul>
			</section>
			<div className="line background-main-light"></div>
			<section className="national--card--section">
				<div className="card--grid xxs-w1 xs-w3 md-w3 w4 container">
					{ countriesFiltered.map((country) => (
						<div className="card--block--rounded national--card--item" key={country.code} >
							<div className="resources-item">
								<p className="nopadding additional-img text-center" >
									<img className="flags--wrapper" src={images[country.code.toLowerCase()]} />
								</p>
								<h2 className="text-center" >{ props.literals[`L${country.literalID}`] }</h2>
							</div>
							<p className="btn--block-full left-text download" >
								<a onClick={ onPDFClick(country.name) } className="btn-default btn-main-color btn-full" >{ props.literals.L22188 }</a>
							</p>
						</div>
					))}
				</div>
			</section>
		</div>
	)
}

CountryReportHome.displayName = 'CountryReportHome';
export default connect(null, null)(CountryReportHome);